<template>
    <div class="transformer" @click="hiddenList($event)">
        <Title :firstName="typeName" lastName="TRANSFORMER LOAD" :showIcon="true" @changeTitle="changeTitle" />
        <div class="nameList" v-show="showType">
            <SelectList :selectList="typeList" @tabTitle="tabTypeName" keyk="id" keyval="value"/>
        </div>
        <div class="echarts">
            <div class="tabList" @click="showTransformList" ref="list">
                {{transform}} <i class="el-icon-arrow-down"></i>
            </div>
            <div class="list" v-show="showList" >
                <SelectList :selectList="transformList" @tabTitle="tabTitle" keyk="loop_id" keyval="deviceName"/>
            </div>
            <div class="edata" v-show="typeName == '变压器负载'">
                <div class="edataCon">
                    <p>实时负载率</p>
                    <p>{{seriesData1.length > 0?seriesData1[seriesData1.length - 1] : 0}}<span> kVA</span></p>
                </div>
                <div class="edataCon">
                    <p>变压器容量</p>
                    <p>800<span> kVA</span></p>
                </div>
            </div>
            <div class="edata" v-show="typeName == '变压器温度'">
                <div class="edataCon">
                    <p><span class="square2"></span>A相</p>
                    <p>{{isNaN(Number(mqtt[loopUrl +'/Temperature_A']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/Temperature_A']).toFixed(2)}}<span> ℃</span></p>
                    
                </div>
                <div class="edataCon">
                    <p><span class="square3"></span>B相</p>
                    <p>{{isNaN(Number(mqtt[loopUrl +'/Temperature_B']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/Temperature_B']).toFixed(2)}}<span> ℃</span></p>
                    
                </div>
                <div class="edataCon">
                    <p><span class="square4"></span>C相</p>
                    <p>{{isNaN(Number(mqtt[loopUrl +'/Temperature_C']).toFixed(2))? '--' :Number(mqtt[loopUrl +'/Temperature_C']).toFixed(2)}}<span> ℃</span></p>
                    
                </div>
            </div>
            <div class="eview">
                <Graph :chartId="chartId" :seriesData="seriesData" :seriesData1="seriesData1"  :xData="xData" v-if="seriesData.length  && typeName == '变压器负载'"/>
                <Graph :chartId="chartId" :color="['#df375b']" :seriesData="Ta" :seriesData1="Tb" :seriesData2="Tc" :xData="xData" v-else-if="Ta.length >0 && typeName == '变压器温度'"/>
                <div class="noneData" v-else>
                    暂无数据
                </div>
                <div class="icon" v-show="typeName == '变压器负载'"><span></span> 今日 <span></span> 昨日</div>

            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../components/title/Title')
const SelectList = () => import('../../components/title/selectList')
const Graph = () => import('../../components/echarts/graph.vue')

import { getTodayTime, getTodayYesTime } from '../../utils/common'
import { GetAllTransformer, GetloopHistorycurve } from '../../components/Request'
import { mapState } from 'vuex'
export default {
    data(){
        return {
            chartId:'transformerLoad',
            xData:['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00','24:00',],
            seriesData:[],
            seriesData1:[],
            Ta:[],
            Tb:[],
            Tc:[],
            showList:false,
            showType:false,
            transform:'1#变压器',
            typeName:'变压器负载',
            transformList:[

            ],
            typeList:[
                {
                    id:'b1',
                    value:'变压器负载',
                },
                {
                    id:'b2',
                    value:'变压器温度',
                },
            ],
            // 当前选中的回路
            loopUrl:'TT',
            ydata1:{
                'TT':["64.38","63.61","58.52","52.58","54.84","53.83","54.73","63.37","71.28","286.61", "363.28", "316.13", "372.38", "320.00", "324.87", "341.43", "324.85", "280.00", "270.08", "200.00", "155.05", "111.62", "100.00", "70.56", "67.45"]
            },
            ydata:{
                'TT':["67.45", "66.80", "65.64","68.15", "0.00", "57.69", "60.00","69.93", "108.00", "277.00","359.63", "316.13", "372.38", "340.00", "324.87", "341.43", "324.85", "280.00", "270.08", "170.00", "155.05", "111.62", "70.00", "70.56", "67.45"]
            },
            // 回路三相温度
            Temperature:{
                'TT':{
                    'A': ["33.00", "32.00", "23.00", "31.00", "22.00", "31.00", "22.00", "22.00", "31.00", "34.00", "46.00","35.00", "25.00", "25.00", "34.00", "25.00", "34.00", "25.00", "25.00", "34.00", "36.00", "47.00","25.00", "25.00", "34.00",],
                    'B': ["38.00", "38.00", "23.00", "37.00", "22.00", "37.00", "22.00", "22.00", "37.00", "39.00", "47.00","33.00", "32.00", "23.00", "31.00", "22.00", "31.00", "22.00", "22.00", "31.00", "34.00", "46.00","32.00", "23.00", "31.00"],
                    'C': ["35.00", "25.00", "25.00", "34.00", "25.00", "34.00", "25.00", "25.00", "34.00", "36.00", "47.00","38.00", "38.00", "23.00", "37.00", "22.00", "37.00", "22.00", "22.00", "37.00", "39.00", "47.00","36.00", "47.00","38.00"],
                }
            }
        }
    },
    components:{
        Title,SelectList,Graph
    },
    computed:{
        ...mapState({mqtt:'MQTTObj'})
    },
    mounted(){
        if(this.$store.state.siteId == 26){
            this.getTransformer()

        }else{
            let hour = new Date().getHours() + 1
            this.ydata['TT'] = this.ydata['TT'].splice(0,hour)
            this.Temperature['TT']['A'] = this.Temperature['TT']['A'].splice(0,hour)
            this.Temperature['TT']['B'] = this.Temperature['TT']['B'].splice(0,hour)
            this.Temperature['TT']['C'] = this.Temperature['TT']['C'].splice(0,hour)
            this.tabLoad()
        }
    },
    methods:{
        // 切换变压器
        tabTitle(transform){
            this.transform = transform.deviceName
            this.loopUrl = transform.loop_url.substr(transform.loop_url.indexOf('/') + 1)

            this.tabLoad()

            this.showList = false

            console.log(this.ydata1);
            console.log(this.ydata);
            console.log(this.Temperature);
        },
        // 切换当前负载或者 湿度
        tabTypeName(name){
            this.typeName = name.value
            this.showType = false

            this.tabLoad()
        },
        tabLoad(){
            if(this.typeName == '变压器负载'){
                this.seriesData = this.ydata1[this.loopUrl]
                this.seriesData1 = this.ydata[this.loopUrl]
            }else{
                this.Ta = this.Temperature[this.loopUrl]['A']
                this.Tb = this.Temperature[this.loopUrl]['B']
                this.Tc = this.Temperature[this.loopUrl]['C']
            }
        },
        showTransformList(){
            this.showList = !this.showList
        },
        changeTitle(){
            this.showType = !this.showType
        },
        hiddenList(e){
            let list = this.$refs.list
            if(list && !list.contains(e.target)){
                this.showList = false
            }
        },
        // 根据所有区域获取当前的区域的变压器
        async getTransformer(){
            let res = await GetAllTransformer({areaId:this.$store.state.siteId})
            let transformList = []
            if(res.data.data.list.length > 0){
                res.data.data.list.forEach(val => {
                    transformList.push(val)
                })
            }
            this.transformList = transformList
            this.getLoopHistorycurve(transformList)
            this.getTransformerTemperature(transformList)
        },
        // 获取变压器的历史曲线
        async getLoopHistorycurve(transformList){
            let time = getTodayYesTime()
            
            let ydata = {}

            for(let i = 0;i<transformList.length;i++){
                let data = {
                    deviceLoopId:transformList[i].loop_id,
                    start : `${time.today}T00:00:00Z`,
                    "node": 'P_1h',
                    end : `${time.today}T24:00:00Z`,
                }
                let res = await GetloopHistorycurve(data)
                let points  = res.data.data.points
                let loopUrl = transformList[i].loop_url.substr(transformList[i].loop_url.indexOf('/') + 1)
                this.$set(ydata,loopUrl,[])
                points.forEach(item =>{
                    ydata[loopUrl].push((item.val/1000).toFixed(2))
                })

            }

            let ydata1 = {}

            for(let i = 0;i<transformList.length;i++){
                let data = {
                    deviceLoopId:transformList[i].loop_id,
                    start : `${time.yesterday}T00:00:00Z`,
                    "node": 'P_1h',
                    end : `${time.yesterday}T24:00:00Z`,
                }
                let res = await GetloopHistorycurve(data)
                let points  = res.data.data.points
                let loopUrl = transformList[i].loop_url.substr(transformList[i].loop_url.indexOf('/') + 1)
                
                this.$set(ydata1,loopUrl,[])
                points.forEach(item =>{
                    ydata1[loopUrl].push((item.val/1000).toFixed(2))
                })
            }

            this.ydata1 = ydata1
            this.ydata = ydata
            this.tabTitle(transformList[0])
        },
        // 变压器温度历史曲线 
        async getTransformerTemperature(transformList){
            let time = getTodayTime()
            let that = this
            let T = {}
            
            for(let i = 0;i<transformList.length;i++){
                let data = {
                    deviceLoopId:transformList[i].loop_id,
                    start : `${time}T00:00:00Z`,
                    "node": 'Temperature_1h',
                    end : `${time}T24:00:00Z`,
                }
                let res = await this.$http.loopTemperature(data)
                let loopUrl = transformList[i].loop_url.substr(transformList[i].loop_url.indexOf('/') + 1)
                
                that.$set(T, loopUrl,{
                    'A':[],
                    'B':[],
                    'C':[],
                })

                let Ta = res.data.data.points.a.map(item =>  item = Number(item.val).toFixed(2))
                let Tb = res.data.data.points.b.map(item =>  item = Number(item.val).toFixed(2))
                let Tc = res.data.data.points.c.map(item =>  item = Number(item.val).toFixed(2))
                
                T[loopUrl]['A'] = Ta
                T[loopUrl]['B'] = Tb
                T[loopUrl]['C'] = Tc

            }
            // console.log(T);
            this.Temperature = T
            // this.tabTitle(transformList[0])
            
        }
    }
}
</script>

<style lang="less" scoped>
    .transformer{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 30.3vh;
        left: 2vw;

        .nameList{
            width: 100%;
            height: 7.5vh;
            position: absolute;
            left: 0;
            top: 3.1vh;
            z-index: 10;
        }

        .echarts{
            position: relative;
            height: 28.7vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .tabList{
                font-size: 14rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: rgba(230,243,253, 0.7);
                position: absolute;
                right: 1vh;
                top: 1vh;
                cursor: pointer;
            }

            .list{
                height: 10.5vh;
                width: 100%;
                position: absolute;
                left: 0;
                top: 3.2vh;
                z-index: 11;
            }

            .edata{
                height: 9vh;
                display: flex;
                justify-content: space-around;
                padding: 3vh 0;
                .edataCon{
                    text-align: center;
                    position: relative;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                        &>span{
                            display: inline-block;
                            width: 12rem;
                            height: 12rem;
                            margin-right: 0.2vw;
                        }
                        .square2{
                            background-color: #df375b;
                        }
                        .square3{
                            background-color: #ffcd8b;
                        }
                        .square4{
                            background-color: #5ad8ce;
                        }
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }
                    
                    
                }
            }

            

            .eview{
                width: 100%;
                padding: 0 0.5vw;
                height: 17.9vh;
                position: relative;
                #transformerChart{
                    width: 100%;
                    height: 100%;
                }
                
                .noneData{
                    display: inline-block;
                    position: absolute;
                    top: 50%;
                    color: rgba(230,243,253, 0.7);
                    left: 50%;
                    transform: translate(-50% , -50%);
                }

                .icon{
                    position: absolute;
                    right: 1vw;
                    top: 0;
                    color: rgba(230,243,253, 0.7);
                    &>span{
                        width: 12rem;
                        height: 12rem;
                        display: inline-block;
                        vertical-align: -1rem;
                        margin-right: 5rem;
                    }
                    &>span:nth-of-type(1){
                        background-color: #f6bd16;
                    }
                    &>span:nth-of-type(2){
                        background-color: #1290ff;
                        margin-left: 5rem;
                    }
                }
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>